import React from 'react';
import { ReactCookieProps } from 'react-cookie';
import ContactForm, {
  Props as ContactFormProps,
} from '~components/ContactForm';
import { WhiteBox } from '~components/styledComponents';

type Props = Omit<ContactFormProps, keyof ReactCookieProps>;

const ContactFormBlock = (contactFormProps: Props) => (
  <WhiteBox>
    <ContactForm {...contactFormProps} />
  </WhiteBox>
);

export default ContactFormBlock;
